export const projectStep = [
  'Initiated',
  'In Progress',
  'In Review',
  'Completed',
];

export const projectFormStep = [
  {
    path: 'projectDetail',
    label: 'Project Details',
  },
  {
    path: 'teamsDetails',
    label: 'PwC Team',
  },
  {
    path: 'clientDetails',
    label: 'Client Team',
  },
  {
    path: 'groupDetails',
    label: 'Groups',
  },
  {
    path: 'moduleSetting',
    label: 'Module Setting',
  },
  {
    path: 'projectInitiated',
    label: 'Project Initiated',
  },
];

export const INTERGTATION_NAV_NAME_DEFAULT = 'Integration Navigator';

export const projectMock = {
  listData: [
    {
      projectId: '1',
      projectName: 'TubeMogul',
      buyerName: 'Nestle',
      buyerIndustry: 'FMCG',
      targetIndustry: 'Containers/Packaging',
      dealAnnouncedDate: '2020-02-19T13:57:10.713Z',
      dealCloseDate: '2020-02-21T13:57:10.000Z',
      engagementStartDate: '2020-02-23T13:57:10.000Z',
      endEndDate: '2020-02-26T13:57:10.000Z',
      lastUpdate: '2020-02-29T13:57:10.000Z',
      engLeader: 'Mark',
      engDirector: 'William',
      projectPhaseId: 2,
      projectStatusId: 1,
      targetId: 'Golden Arches',
    },
    {
      projectId: '2',
      projectName: 'Whole Foods Market',
      buyerName: 'Nestle',
      buyerIndustry: 'FMCG',
      targetIndustry: 'Finance',
      dealAnnouncedDate: '2020-02-19T13:57:10.713Z',
      dealCloseDate: '2020-02-21T13:57:10.000Z',
      engagementStartDate: '2020-02-23T13:57:10.000Z',
      endEndDate: '2020-02-26T13:57:10.000Z',
      lastUpdate: '2020-02-29T13:57:10.000Z',
      engLeader: 'Mark',
      engDirector: 'William',
      projectPhaseId: 3,
      projectStatusId: 2,
      targetId: 'Merriweather Financial',
    },
  ],
};

export const projectRole = {
  Contributor: 'Contributor',
  'View-Only': 'View-Only',
};

export const projectRoleOptions = [
  {
    value: projectRole.Contributor,
    label: 'Admin',
    description: 'Manage people, settings, and edit content',
  },
  {
    value: projectRole['View-Only'],
    label: 'Viewer',
    description: 'Read-only, no editing',
  },
];

export const projectRoleOptionForNonUs = [
  {
    value: projectRole['View-Only'],
    label: 'Viewer',
    description: 'Read-only, no editing',
  },
];

export const oldProjectRoleNames = [
  'Engagement Lead',
  'Engagement Manager',
  'Team Member',
  'Custom Role',
];

export const SecondaryUseTips =
  'If a contract has been signed, Please confirm that the signed engagement contract includes a secondary use clause for data sharing.';

export const ThemeType = {
  dark: 'dark',
  light: 'light',
};
